import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../../../components/base/PageLayout';
const SocialEtiquette: React.FC = () => {
  React.useEffect(() => {
    document.title = '社交のエチケット - 執事直伝のパーティー・挨拶・名刺交換マナー｜執事ベル';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '執事ベルが伝授する社交の場でのエチケット。パーティーでの立ち居振る舞い、初対面の挨拶と自己紹介、名刺交換のマナー、会話の進め方、席次のルールなど、社交シーンで必要な知識を網羅的に解説。ビジネスの会食、異業種交流会、結婚披露宴など、様々な社交の場で好印象を与え、人脈を広げるための実践的なエチケットをお伝えします。');
    }
  }, []);


  return (
    <PageLayout hero={<>
<div className="relative h-96 bg-gradient-to-r from-gray-900 to-gray-700 flex items-center justify-center">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
            style={{
              backgroundImage: `url('/images/generated/seq-social-hero-38b885.jpg')`
            }}
          />
          <div className="relative z-10 text-center text-white max-w-6xl mx-auto px-6">
            <h1 className="text-5xl md:text-6xl font-serif mb-6 tracking-wide">
              社交のエチケット
            </h1>
            <p className="text-xl md:text-2xl font-light italic opacity-90">
              The Art of Social Etiquette
            </p>
          </div>
        </div>
</>}>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        

        {/* Article Content */}
        <div className="max-w-6xl mx-auto px-6 py-16">
          <div className="prose prose-lg max-w-none">
            {/* Introduction */}
            <div className="mb-12 p-8 bg-gradient-to-r from-amber-50 to-yellow-50 rounded-lg border-l-4 border-amber-600">
              <p className="text-lg leading-relaxed text-gray-800 mb-0">
                社交の場でのエチケットは、人間関係を円滑にし、相互の尊重を示す重要な技術です。パーティーや公式な集まりにおいて、適切な振る舞いができることは、その人の品格と教養を表します。執事として数多くの社交の場に立ち会った経験から、洗練された社交術をお伝えいたします。
              </p>
            </div>

            {/* Main Content */}
            <div className="space-y-12">
              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  パーティーでの基本マナー
                </h2>
                <div className="grid md:grid-cols-2 gap-8 items-center mb-8">
                  <div>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      パーティーや社交の場では、到着から退席まで、一連の流れに沿った適切な振る舞いが求められます。特に重要なのは、時間の管理と他の参加者への配慮です。
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      到着時間は招待状に記載された時間の15分後が理想的です。早すぎても遅すぎても、主催者に迷惑をかけてしまいます。
                    </p>
                  </div>
                  <div className="relative">
                    <img 
                      src="/images/generated/seq-social-arrival-2f4f47.jpg"
                      alt="パーティーでの到着マナー"
                      className="w-full h-80 object-cover rounded-lg shadow-lg"
                    />
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  紹介と挨拶の作法
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6">
                  社交の場での紹介と挨拶は、第一印象を決定づける重要な瞬間です。適切な順序と方法を理解し、相手に敬意を示すことが大切です。
                </p>
                
                <div className="bg-white border border-gray-200 rounded-lg p-6 mb-8">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">紹介の基本ルール</h3>
                  <div className="space-y-4">
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-amber-700 text-white rounded-full flex items-center justify-center font-semibold text-sm">1</div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">年長者を優先</h4>
                        <p className="text-gray-700">年下の方を年長の方に紹介します</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-amber-700 text-white rounded-full flex items-center justify-center font-semibold text-sm">2</div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">地位の高い方を優先</h4>
                        <p className="text-gray-700">地位の低い方を高い方に紹介します</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-amber-700 text-white rounded-full flex items-center justify-center font-semibold text-sm">3</div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">男性を女性に紹介</h4>
                        <p className="text-gray-700">伝統的なマナーでは、男性を女性に紹介します</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-amber-700 text-white rounded-full flex items-center justify-center font-semibold text-sm">4</div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">明確で簡潔に</h4>
                        <p className="text-gray-700">相手の名前と簡単な紹介を明確に伝えます</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="relative">
                    <img 
                      src="/images/generated/seq-social-intro-3ef7b9.jpg"
                      alt="紹介と挨拶の作法"
                      className="w-full h-80 object-cover rounded-lg shadow-lg"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">握手のマナー</h3>
                    <ul className="space-y-3 text-gray-700">
                      <li className="flex items-start space-x-3">
                        <i className="ri-check-line text-amber-600 mt-1"></i>
                        <span>相手の目を見て握手する</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <i className="ri-check-line text-amber-600 mt-1"></i>
                        <span>適度な力加減で2-3秒間</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <i className="ri-check-line text-amber-600 mt-1"></i>
                        <span>手のひら全体で握る</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <i className="ri-check-line text-amber-600 mt-1"></i>
                        <span>笑顔を忘れずに</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  会話術とネットワーキング
                </h2>
                <div className="grid md:grid-cols-2 gap-8 items-center mb-8">
                  <div>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      社交の場での会話は、単なる情報交換ではありません。相手との関係を築き、お互いを理解し合う貴重な機会です。
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      良い聞き手になることが、優れた会話術の基本です。相手の話に真摯に耳を傾け、適切な質問を投げかけることで、有意義な対話が生まれます。
                    </p>
                  </div>
                  <div className="relative">
                    <img 
                      src="/images/generated/seq-social-conversation-2abf65.jpg"
                      alt="社交での会話術"
                      className="w-full h-80 object-cover rounded-lg shadow-lg"
                    />
                  </div>
                </div>

                <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-8 rounded-lg mb-8">
                  <h3 className="text-xl font-semibold text-gray-900 mb-6">効果的な会話のテクニック</h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div className="flex items-center space-x-3">
                        <i className="ri-question-line text-amber-600 text-xl"></i>
                        <span className="text-gray-800">オープンエンドな質問を使う</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-ear-line text-amber-600 text-xl"></i>
                        <span className="text-gray-800">アクティブリスニングを実践</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-share-line text-amber-600 text-xl"></i>
                        <span className="text-gray-800">共通の話題を見つける</span>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div className="flex items-center space-x-3">
                        <i className="ri-smile-line text-amber-600 text-xl"></i>
                        <span className="text-gray-800">ポジティブな話題を選ぶ</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-time-line text-amber-600 text-xl"></i>
                        <span className="text-gray-800">適切なタイミングで話題転換</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-heart-line text-amber-600 text-xl"></i>
                        <span className="text-gray-800">相手への関心を示す</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  食事とドリンクのマナー
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6">
                  社交の場での食事やドリンクは、会話を促進する重要な要素です。しかし、食べ方や飲み方にも配慮が必要で、品格ある振る舞いが求められます。
                </p>
                
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">
                      <i className="ri-restaurant-line text-amber-600 mr-2"></i>
                      立食パーティー
                    </h3>
                    <ul className="text-gray-700 space-y-2 text-sm">
                      <li>• 片手で食べられるものを選ぶ</li>
                      <li>• 小皿を活用する</li>
                      <li>• 食べながら話さない</li>
                      <li>• ナプキンを常に携帯</li>
                    </ul>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">
                      <i className="ri-goblet-line text-amber-600 mr-2"></i>
                      ドリンクマナー
                    </h3>
                    <ul className="text-gray-700 space-y-2 text-sm">
                      <li>• 適量を心がける</li>
                      <li>• グラスを正しく持つ</li>
                      <li>• 乾杯時は目を見る</li>
                      <li>• 飲み過ぎに注意</li>
                    </ul>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">
                      <i className="ri-cake-line text-amber-600 mr-2"></i>
                      デザート
                    </h3>
                    <ul className="text-gray-700 space-y-2 text-sm">
                      <li>• 小さく切って食べる</li>
                      <li>• 音を立てない</li>
                      <li>• 美しい姿勢を保つ</li>
                      <li>• 感謝の気持ちを表現</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  退席のタイミングとマナー
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6">
                  社交の場からの退席も、到着と同様に重要なマナーがあります。適切なタイミングで、感謝の気持ちを込めて退席することが大切です。
                </p>
                
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-green-800 mb-4">
                      <i className="ri-check-line mr-2"></i>
                      適切な退席
                    </h3>
                    <ul className="space-y-2 text-green-700">
                      <li>• 主催者に挨拶してから退席</li>
                      <li>• 感謝の気持ちを伝える</li>
                      <li>• 他の参加者にも簡潔に挨拶</li>
                      <li>• 静かに会場を後にする</li>
                      <li>• 後日お礼の連絡をする</li>
                    </ul>
                  </div>
                  
                  <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-red-800 mb-4">
                      <i className="ri-close-line mr-2"></i>
                      避けるべき行動
                    </h3>
                    <ul className="space-y-2 text-red-700">
                      <li>• 挨拶なしでの退席</li>
                      <li>• 大きな音を立てる</li>
                      <li>• 長時間の別れの挨拶</li>
                      <li>• 他の参加者の邪魔をする</li>
                      <li>• 批判的なコメント</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  デジタル時代の社交マナー
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6">
                  現代の社交の場では、スマートフォンやSNSとの付き合い方も重要なマナーの一部となっています。テクノロジーを適切に活用しながら、人間関係を大切にすることが求められます。
                </p>
                
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
                  <h3 className="text-lg font-semibold text-blue-800 mb-4">
                    <i className="ri-smartphone-line mr-2"></i>
                    スマートフォンのマナー
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <ul className="space-y-2 text-blue-700">
                      <li>• 会話中は使用を控える</li>
                      <li>• 緊急時以外は電源オフまたはマナーモード</li>
                      <li>• 写真撮影は許可を得てから</li>
                    </ul>
                    <ul className="space-y-2 text-blue-700">
                      <li>• SNS投稿は慎重に</li>
                      <li>• プライバシーに配慮</li>
                      <li>• 目の前の人との時間を大切に</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-3xl font-serif text-gray-900 mb-6 border-b-2 border-amber-600 pb-3">
                  国際的な社交マナー
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6">
                  グローバル化が進む現代では、異なる文化的背景を持つ方々との社交の機会が増えています。文化の違いを理解し、相手に敬意を示すことが重要です。
                </p>
                
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-amber-800 mb-3">
                    <i className="ri-lightbulb-line mr-2"></i>
                    執事ベルからのアドバイス
                  </h3>
                  <p className="text-amber-700 leading-relaxed">
                    「社交のエチケットの本質は、相手への思いやりと敬意です。形式的なルールも大切ですが、最も重要なのは、相手が心地よく過ごせるよう配慮することです。真の社交術は、技術ではなく、人間性から生まれるものなのです。自然体でありながら、品格を保つ。それが真の社交の極意です。」
                  </p>
                </div>
              </section>
            </div>

            {/* Related Articles */}
            <div className="mt-16 pt-12 border-t border-gray-200">
              <h3 className="text-2xl font-serif text-gray-900 mb-8">関連記事</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <a href="/wisdom/articles/communication" className="group block bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300">
                  <img 
                    src="/images/generated/seq-related-comm3-54928b.jpg"
                    alt="コミュニケーション術"
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-900 group-hover:text-amber-600 transition-colors">コミュニケーション術</h4>
                    <p className="text-sm text-gray-600 mt-2">心に響く会話と信頼関係の築き方</p>
                  </div>
                </a>
                
                <a href="/wisdom/articles/dress-code" className="group block bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300">
                  <img 
                    src="/images/generated/seq-related-dress2-7e02f6.jpg"
                    alt="ドレスコードの基本"
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-900 group-hover:text-amber-600 transition-colors">ドレスコードの基本</h4>
                    <p className="text-sm text-gray-600 mt-2">場面に応じた適切な装いの選び方</p>
                  </div>
                </a>
                
                <a href="/wisdom/articles/table-manners" className="group block bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300">
                  <img 
                    src="/images/generated/seq-related-table3-353056.jpg"
                    alt="テーブルマナーの美学"
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-900 group-hover:text-amber-600 transition-colors">テーブルマナーの美学</h4>
                    <p className="text-sm text-gray-600 mt-2">フォーマルディナーでの作法</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default SocialEtiquette;
